module.exports = __webpack_public_path__ + "img/python-logo.b9bbb1d7.png";